/* yappyヘッダー。波形付きモバイルメニューの開閉、フォーカス制御、スクロール固定、Escキー対応を行う。 */
(function () {
  "use strict";

  var OPEN = "data-open";
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])';
var TOP_SCROLL_THRESHOLD = 100; // 透明な上部バーを不透明に切り替えるまでのスクロール量(px)

  function initInstance(root) {
    if (!root || root.dataset.yappyInit === "true") return;

    var toggle = root.querySelector(".header-yappy__toggle");
    var overlay = root.querySelector(".header-yappy__overlay");
    var panel = root.querySelector(".header-yappy__panel");
    var closeBtn = root.querySelector(".header-yappy__close");
    var scrim = root.querySelector(".header-yappy__scrim");

    // 必要な要素がない場合は、エラーにせず初期化を中止する。
    if (!toggle || !overlay || !panel) return;
    root.dataset.yappyInit = "true";

    var isOpen = false;
    var lastFocused = null;
    var scrollY = 0;

    function focusable() {
      return Array.prototype.slice.call(panel.querySelectorAll(FOCUSABLE)).filter(function (el) {
        return el.offsetParent !== null;
      });
    }

    function lockScroll() {
      scrollY = window.scrollY || window.pageYOffset || 0;
      document.body.style.position = "fixed";
      document.body.style.top = "-" + scrollY + "px";
      document.body.style.left = "0";
      document.body.style.right = "0";
      document.body.style.width = "100%";
    }

    function unlockScroll() {
      document.body.style.position = "";
      document.body.style.top = "";
      document.body.style.left = "";
      document.body.style.right = "";
      document.body.style.width = "";
      window.scrollTo(0, scrollY);
    }

    function onKeydown(event) {
      if (event.key === "Escape" || event.keyCode === 27) {
        event.preventDefault();
        close();
        return;
      }
      if (event.key !== "Tab" && event.keyCode !== 9) return;

      var items = focusable();
      if (items.length === 0) return;

      var first = items[0];
      var last = items[items.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    function open() {
      if (isOpen) return;
      isOpen = true;
      lastFocused = document.activeElement;

      overlay.classList.add("is-active");
      // パネルの閉じた状態からトランジションを開始するため、再描画を強制する。
      void overlay.offsetWidth;

      overlay.setAttribute(OPEN, "true");
      overlay.setAttribute("aria-hidden", "false");
      toggle.setAttribute("aria-expanded", "true");

      lockScroll();
      (closeBtn || focusable()[0] || panel).focus({ preventScroll: true });
      document.addEventListener("keydown", onKeydown);
    }

    function close() {
      if (!isOpen) return;
      isOpen = false;

      overlay.setAttribute(OPEN, "false");
      overlay.setAttribute("aria-hidden", "true");
      toggle.setAttribute("aria-expanded", "false");

      document.removeEventListener("keydown", onKeydown);
      unlockScroll();

      if (lastFocused && typeof lastFocused.focus === "function") {
        lastFocused.focus({ preventScroll: true });
      }
    }

    // 閉じるアニメーションが終わったらオーバーレイを隠す。
    // これによりアクセシビリティツリーから外れ、波のアニメーションも止まる。
    panel.addEventListener("transitionend", function (event) {
      if (event.target !== panel) return;
      if (event.propertyName !== "transform" && event.propertyName !== "opacity") return;
      if (overlay.getAttribute(OPEN) !== "true") {
        overlay.classList.remove("is-active");
      }
    });

    toggle.addEventListener("click", open);
    if (closeBtn) closeBtn.addEventListener("click", close);
    if (scrim) scrim.addEventListener("click", close);

    // トップページのみ、一定量スクロールしたら透明バーを不透明にする。
    var bar = root.querySelector(".header-yappy__bar");
    if (bar && root.classList.contains("header-yappy--sticky-top")) {
      var syncScrolled = function () {
        var y = window.scrollY || window.pageYOffset || 0;
        bar.classList.toggle("is-scrolled", y > TOP_SCROLL_THRESHOLD);
      };
      syncScrolled();
      window.addEventListener("scroll", syncScrolled, { passive: true });
    }
  }

  function initAll(scope) {
    var nodes = (scope || document).querySelectorAll(".header-yappy");
    Array.prototype.forEach.call(nodes, initInstance);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initAll();
    });
  } else {
    initAll();
  }

  // テーマエディタでセクションが再描画された時に、もう一度初期化する。
  document.addEventListener("shopify:section:load", function (event) {
    initAll(event.target);
  });
})();
